var React = require('react');

function ROverviewInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"54","height":"54","rx":"6","fill":"#E8F0FF","key":0}),React.createElement("path",{"d":"M40.9091 43.2274H13.0909C11.384 43.2274 10 41.8434 10 40.1365V15.4092H22.3636L27 21.591H44V40.1365C44 41.8434 42.616 43.2274 40.9091 43.2274Z","stroke":"#090D12","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M13.0908 10.7727H40.909V16.9545","stroke":"#1769FF","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ROverviewInline.defaultProps = {"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none"};

module.exports = ROverviewInline;

ROverviewInline.default = ROverviewInline;
